var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDfkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5569 25H9.44315L3 18.5569V9.44315L9.44315 3H18.5558L25 9.44315V18.5558L18.5569 25ZM10.0135 23.625H17.9875L23.626 17.9865V10.0135L17.9865 4.375H10.0135L4.375 10.0135V17.9875L10.0135 23.625V23.625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4632 12.7529V16.6773L17.2029 19.9376L16.4309 18.0727L18.5983 15.9053V15.3257H17.2233V15.3359L15.3349 17.2242H12.6644L10.776 15.3359V12.6643L12.6644 10.776H15.3349L17.2233 12.6643V12.6816H18.5983V12.095L16.4309 9.92757L17.2029 8.06266L18.2265 9.08628C18.1786 9.23396 18.1511 9.39183 18.1511 9.55683C18.1511 10.3951 18.8305 11.0744 19.6687 11.0744C20.507 11.0744 21.1863 10.3951 21.1863 9.55683C21.1863 8.71859 20.507 8.03924 19.6687 8.03924C19.5047 8.03924 19.3469 8.06572 19.1982 8.11461L17.2457 6.16211H10.7526L6.16113 10.7526V17.2456L10.7526 21.8371H17.2457L21.8372 17.2456V12.7529H20.4632V12.7529ZM12.8385 18.5982H15.1597L15.9318 20.4631H12.0665L12.8385 18.5982ZM11.5684 18.0716L10.7964 19.9366L8.06271 17.2028L9.92761 16.4308L11.5684 18.0716ZM9.40104 12.8385V15.1597L7.53613 15.9317V12.0665L9.40104 12.8385V12.8385ZM9.9266 11.5684L8.06169 10.7964L10.7954 8.06266L11.5674 9.92757L9.9266 11.5684ZM12.0665 7.53609H15.9328L15.1608 9.401H12.8385L12.0665 7.53609V7.53609Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfkWhite);
export default __webpack_public_path__ + "static/media/dfk-white.fec202bc4c0ba04381c7ea0805daa145.svg";
export { ForwardRef as ReactComponent };